import { render, staticRenderFns } from "./Sum.vue?vue&type=template&id=16c024ff&scoped=true"
import script from "./Sum.vue?vue&type=script&lang=js"
export * from "./Sum.vue?vue&type=script&lang=js"
import style0 from "./Sum.vue?vue&type=style&index=0&id=16c024ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c024ff",
  null
  
)

export default component.exports